import type { StateType } from '../../lib/types/state-type';
import type { FurnhomeCommunication } from '@dh-software/furnhome-communication';

export function logout(state: StateType, communication: FurnhomeCommunication): StateType {
  window.location.href = communication.getLogoutUrl();
  // Die Sub-Routen gehoeren zur Sitzung: der naechste Benutzer faengt in jedem Modul vorne an.
  return { ...state, loggedIn: false, page: 'login', moduleRoutes: {} };
}
